import { FC } from 'react'
import { CountryType } from '../../../../types/CountryType'
import { IdCard } from './components/IdCard'
import { PersonalInformation } from './components/PersonalInformation'
import { ResidencePermit } from './components/ResidencePermit'
import { WorkPermit } from './components/WorkPermit'

interface Props {
  countries: CountryType[]
}

export const FormContent: FC<Props> = ({ countries }) => {
  return (
    <>
      <PersonalInformation countries={countries} />
      <IdCard countries={countries} />
      <ResidencePermit countries={countries} />
      <WorkPermit countries={countries} />
    </>
  )
}
